export default __webpack_public_path__ + "static/mask_slide_new-5bae20aefe0f02e356200037d0763897.jpg";